module.exports = __webpack_public_path__ + "acc941f8fd49ba8993f957e3591daa1c.png";